export interface IAttachment {
  _id?: string;
  originName: string;
  physicalName: string;
  size: number;
  type: ATTACHMENT_TYPES;
  content: string;
}

export enum ATTACHMENT_TYPES {
  IMAGE = 'image',
  VIDEO = 'video',
  PDF = 'pdf',
}
